module.exports = "<app-object-viewer title=\"User Profile\" [value]=\"userProfile\"></app-object-viewer>"